<app-header></app-header>

<!-- HERO (unchanged) -->
<section class="ng-hero">
  <div class="dark-grid"></div>
  <div class="ng-grain"></div>
  <div class="gold-bar-left"></div>
  <div class="hero-sweep"></div>
  <div class="hero-inner">
    <div>
      <div class="hero-eyebrow reveal">THE NEXGEN COMMUNITY</div>
      <h1 class="reveal d1">One community.<br>Every coach<br><em>welcome.</em></h1>
      <div class="hero-rule reveal d2"></div>
      <p class="hero-sub reveal d2">
        Many coaches are looking for two things: <strong>a real coaching network</strong> and
        <strong>a way to earn their coaching hours.</strong> Both can be hard to find.<br><br>
        NEXGEN brings coaches together to practice, support each other, and grow.
      </p>
      <!-- <div class="hero-goal reveal d3">Our goal is simple. Build a remarkable coaching community.</div> -->
      <div class="hero-btns reveal d4">
        <button class="btn-gold" (click)="goToUrl()">Join the Community</button>
        <button class="btn-outline" (click)="openLatestUpcomingSessionModal()">Register for Coach for the Cause</button>
      </div>
    </div>
    <div class="hero-stats reveal d3">
      <div class="hstat">
        <div class="hn">You</div>
        <div class="hl">belong here. Come as you are.</div>
      </div>
      <div class="hstat">
        <div class="hn">${{ currentMonthSession?.price || '19.95' }}</div>
        <div class="hl">per session — all net proceeds donated to support the cause</div>
      </div>
      <div class="hstat">
        <div class="hn">12</div>
        <div class="hl">months, twelve causes — one remarkable coaching community</div>
      </div>
    </div>
  </div>
</section>

<!-- TWO WAYS -->
<section class="two-ways">
  <div class="grain-cream"></div>
  <div class="two-ways-inner">
    <div class="two-ways-head reveal">
      <div class="eyebrow dk">Two Ways to Be Part of the Community</div>
      <h2>The community is built around two <em>simple ideas.</em></h2>
      <div class="rule"></div>
      <p>Everyone is welcome
        to participate.</p>
    </div>
    <div class="two-ways-cards">
      <div class="tw-card reveal d1">
        <div class="cn">01</div>
        <div class="ct">Coach for <em>the Cause</em></div>
        <div class="cbar"></div>
        <div class="cb">Monthly live barter coaching sessions open to all ICF students, certified coaches and anyone
          who needs coaching hours. Just $19.95 per session — and all net proceeds go to that month's featured charity.
        </div>
      </div>
      <div class="tw-card reveal d2">
        <div class="cn">02</div>
        <div class="ct">NEXGEN <em>Research Lab</em></div>
        <div class="cbar"></div>
        <div class="cb">Where coaches and students contribute to the field — through white papers, studies, fireside
          chats, and research partnerships with universities and colleges on leadership, EQ, neuroscience, and human
          behavior.</div>
      </div>
    </div>
  </div>
</section>

<!-- COACH FOR THE CAUSE - DYNAMIC -->
<section class="cftc-section" id="cftc">
  <div class="ng-grain"></div>
  <div class="cftc-inner">
    <div class="cftc-left">
      <div class="eyebrow1 reveal">Coach for the Cause</div>
      <h2 class="reveal d1">Practice coaching.<br>Earn your hours.<br><em>Help people.</em></h2>
      <div class="cftc-rule reveal d1"></div>
      <p class="cftc-body reveal d2">
        Many coaches working toward their <a href="https://academy.nexgencoaches.com/icf-overview" target="_blank" rel="noopener noreferrer" aria-label="Understand ICF certification requirements">ICF certification</a> struggle to find coaching hours. That's where the community
        helps.<br><br>
        Through Coach for the Cause, coaches meet in live sessions to coach each other and support people who need it.
      </p>
      <div class="cftc-simple reveal d2">You coach someone. Someone coaches you. Simple.</div>
      <div class="cftc-label reveal d3">These sessions help you:</div>
      <ul class="cftc-list reveal d3">
        <li>Practice real coaching with real people</li>
        <li>Build confidence in your coaching skill</li>
        <li>Earn coaching hours toward <a href="https://academy.nexgencoaches.com/icf-overview" target="_blank" rel="noopener noreferrer" aria-label="ICF ACC and PCC credentials explained">ICF credentials</a></li>
        <li>Meet other coaches from every background</li>
        <li>Grow your coaching network</li>
      </ul>
      <p class="cftc-body reveal d3">
        And at the same time, <strong>we help people through Coach for the Cause charity coaching sessions.</strong>
        Coaching becomes a way to serve others while building your practice.
      </p>
      <div class="for-section reveal d4">
        <div class="for-label">Built for Every Coach</div>
        <div class="for-intro">You do not need to be a NEXGEN student. The community welcomes:</div>
        <ul class="for-types">
          <li>New <a href="https://academy.nexgencoaches.com/icf-overview" target="_blank" rel="noopener noreferrer" aria-label="ICF certified coach credentials">ICF certified coaches</a></li>
          <li>Experienced ICF certified coaches</li>
          <li><a href="https://academy.nexgencoaches.com/icf-overview" target="_blank" rel="noopener noreferrer" aria-label="ICF certification pathway">ICF certification candidates</a></li>
        </ul>
        <div class="for-close">If you are on the path of coaching, you belong here.</div>
      </div>
    </div>

    <!-- UPCOMING SESSION CARD (Most Recent Upcoming) -->
<div class="reveal d2">
  <div class="cftc-card" *ngIf="!loadingSessions && upcomingSession">
    <div class="card-this-month">
      <span>{{ getFormattedUpcomingMonth() }} — Upcoming Session</span>
    </div>
    <div class="card-body-wrap">
      <div class="card-title">{{ upcomingSession.title }}</div>
      <div class="card-cause" *ngIf="upcomingSession.causeLabel">{{ upcomingSession.causeLabel }}</div>
      <div class="card-price">${{ upcomingSession.price }}</div>
      <div class="card-proceeds" *ngIf="upcomingSession.charity">All net proceeds donated to {{
        upcomingSession.charity }}</div>
      <div class="card-divider"></div>
      <ul class="card-bullets">
        <li>Live group barter coaching session — real people, real practice</li>
        <li>Counts toward ICF coaching hours for credentialing</li>
        <li *ngIf="upcomingSession.instructor">Facilitated by {{ upcomingSession.instructor?.firstName }} {{
          upcomingSession.instructor?.lastName }}</li>
        <li>Open to all — any school, any credential level</li>
        <li *ngIf="upcomingSession.charity">Supporting: {{ upcomingSession.charity }}</li>
        <li>Certificate of participation provided</li>
      </ul>
      <div class="card-notice">
        <p *ngIf="upcomingSession.charity"><strong>Every penny after processing goes to {{
            upcomingSession.charity }}.</strong></p>
      </div>

      <!-- Session dates -->
      <div class="card-session-dates" *ngIf="upcomingSession.sessions?.length">
        <h4>Upcoming Session:</h4>
        <div class="session-date-item" *ngFor="let session of upcomingSession.sessions">
          <i class="bi bi-calendar"></i>
          {{ formatDate(session.date) }} at {{ formatTime(session.startTime) }} EST
          <span class="spot-indicator" [class.low-spots]="upcomingSession.availableSpots < 5">
            {{ getAvailableSpotsText(upcomingSession) }}
          </span>
        </div>
      </div>

      <button class="card-btn" (click)="openRegistrationModal(upcomingSession, upcomingSession.sessions[0])"
        [disabled]="isFullyBooked(upcomingSession)">
        {{ isFullyBooked(upcomingSession) ? 'Fully Booked' : 'Register for $' + upcomingSession.price }}
      </button>
    </div>
  </div>

  <!-- Fallback if no upcoming session -->
  <div class="cftc-card" *ngIf="!loadingSessions && !upcomingSession">
    <div class="card-this-month">
      <span>No Upcoming Sessions</span>
    </div>
    <div class="card-body-wrap">
      <div class="card-title">Check Back Soon</div>
      <div class="card-cause">New sessions added regularly</div>
      <div class="card-price">$19.95</div>
      <div class="card-proceeds">All net proceeds donated to support the cause</div>
      <div class="card-divider"></div>
      <ul class="card-bullets">
        <li>Live group barter coaching sessions</li>
        <li>Counts toward <a href="https://academy.nexgencoaches.com/icf-overview" target="_blank" rel="noopener noreferrer" aria-label="ICF coaching hours for credentialing">ICF coaching hours</a> for credentialing</li>
        <li>Facilitated by NEXGEN instructors</li>
        <li>Open to all — any school, any credential level</li>
        <li>New charity featured every month</li>
        <li>Certificate of participation provided</li>
      </ul>
      <div class="card-notice">
        <p>We're planning new sessions soon. Check back for updates!</p>
        <p><strong>Every penny after processing goes to that month's featured charity.</strong></p>
      </div>
      <button class="card-btn" disabled>Coming Soon</button>
      <div class="card-meta">
        <span>Sessions run monthly</span>
        <span>Dates announced 2 weeks prior</span>
        <span>Limited spots</span>
      </div>
    </div>
  </div>

  <!-- Loading state -->
  <div class="cftc-card loading-card" *ngIf="loadingSessions">
    <div class="card-body-wrap">
      <div class="loading-spinner"></div>
      <p>Loading upcoming session...</p>
    </div>
  </div>
</div>
  </div>
</section>

<!-- FEATURES -->
<section class="features-section">
  <div class="grain-cream"></div>
  <div class="features-inner">
    <div class="features-head reveal">
      <div class="section-label">The Coaching Ecosystem</div>
      <h2>An all-inclusive community for coaches at <em>every stage.</em></h2>
      <div class="rule"></div>
      <p>Regardless of school, credential, or experience level. Peer learning, collaboration, and real connection
        between people who are serious about this work.</p>
    </div>
    <div class="features-grid">
      <div class="feat-box reveal d1">
        <h3>Monthly Live Barter Sessions</h3>
        <div class="fbar"></div>
        <p>Every month, we open a live group barter coaching session to the entire community. Practice real coaching,
          log real hours, and connect with coaches from every background — all for $19.95. All net proceeds donated to
          support the cause.</p>
      </div>
      <div class="feat-box reveal d2">
        <h3>Peer Collaboration &amp; Learning</h3>
        <div class="fbar"></div>
        <p>Spaces for coaches to share resources, discuss approaches, ask questions, and learn from one another. The
          kind of exchange that makes everyone in the room better.</p>
      </div>
      <div class="feat-box reveal d3">
        <h3>Research &amp; Publication Access</h3>
        <div class="fbar"></div>
        <p>Community members get early access to NEXGEN Research Lab publications — white papers, interviews, studies,
          and fireside chats from leading voices in coaching and leadership science.</p>
      </div>
      <div class="feat-box reveal d4">
        <h3>Annual Coaching for Humanity Campaigns</h3>
        <div class="fbar"></div>
        <p>Twelve months of purpose-driven coaching events, each tied to a cause that matters. Give your coaching hours
          meaning beyond the session room. All net proceeds donated to support the cause.</p>
      </div>
    </div>
  </div>
</section>

<!-- CALENDAR - DYNAMIC -->
<section class="calendar-section">
  <div class="calendar-inner">
    <div class="calendar-head reveal">
      <div class="eyebrow dk">Annual Coaching for Humanity</div>
      <h2>Twelve months.<br><em>Twelve causes.</em></h2>
      <div class="rule"></div>
      <p>Every month NEXGEN aligns its barter coaching sessions with a cause that reflects real human experience. All
        net proceeds donated to support the cause.</p>
    </div>

    <!-- Loading State -->
    <div class="loading-grid" *ngIf="loadingSessions">
      <div class="loader-spinner"></div>
      <p>Loading sessions...</p>
    </div>

    <!-- Calendar Grid -->
<div class="calendar-grid" *ngIf="!loadingSessions">
  <ng-container *ngFor="let month of calendarMonths">
    
    <ng-container *ngIf="getSessionsForMonthKey(month.monthName, month.year) as sessions">
      
      <!-- Month HAS sessions -->
      <ng-container *ngIf="sessions.length > 0">
        
        <!-- If multiple sessions in this month, wrap them in a grouped cell -->
        <div class="cal-month-group" *ngIf="sessions.length > 1">
          <span class="cal-tag">{{ month.monthName }} {{ month.year }}</span>
          <div 
  class="cal-month has-session multi-session reveal"
  *ngFor="let session of sessions; let i = index"
  [class.past-month]="isMonthKeyPast(month.monthName, month.year)"
  [class.featured]="isUpcomingSession(session)"
  (click)="!isMonthKeyPast(month.monthName, month.year) && openRegistrationModal(session, session.sessions[0])">
            
            <span class="cal-tag">{{ month.monthName }} {{ month.year }} — Session {{ i + 1 }}</span>
            <div class="cal-name">{{ session.title }}</div>
            <div class="cal-quote" *ngIf="session.quote?.trim()">"{{ session.quote }}"</div>
            <span class="cal-cause-label" *ngIf="session.causeLabel">{{ session.causeLabel }}</span>
            <div class="cal-cause-desc">{{ session.description }}</div>
            <span class="cal-charity">
              <span class="cal-price">${{ session.price }}</span>
              <span *ngIf="session.charity"> {{ session.charity }}</span>
            </span>
            <div class="spots-indicator" *ngIf="!isMonthKeyPast(month.monthName, month.year) && session.availableSpots > 0">
              {{ getAvailableSpotsText(session) }}
            </div>
            <div class="session-status" *ngIf="isMonthKeyPast(month.monthName, month.year)">Session Passed</div>
          </div>
        </div>
        
        <!-- Single session in this month -->
        <div 
  class="cal-month has-session reveal"
  *ngIf="sessions.length === 1"
  [class.past-month]="isMonthKeyPast(month.monthName, month.year)"
  [class.featured]="isUpcomingSession(sessions[0])"
  (click)="!isMonthKeyPast(month.monthName, month.year) && openRegistrationModal(sessions[0], sessions[0].sessions[0])">
          
          <span class="cal-tag">{{ month.monthName }} {{ month.year }}</span>
          <div class="cal-name">{{ sessions[0].title }}</div>
          <div class="cal-quote" *ngIf="sessions[0].quote?.trim()">"{{ sessions[0].quote }}"</div>
          <span class="cal-cause-label" *ngIf="sessions[0].causeLabel">{{ sessions[0].causeLabel }}</span>
          <div class="cal-cause-desc">{{ sessions[0].description }}</div>
          <span class="cal-charity">
            <span class="cal-price">${{ sessions[0].price }}</span>
            <span *ngIf="sessions[0].charity"> {{ sessions[0].charity }}</span>
          </span>
          <div class="spots-indicator" *ngIf="!isMonthKeyPast(month.monthName, month.year) && sessions[0].availableSpots > 0">
            {{ getAvailableSpotsText(sessions[0]) }}
          </div>
          <div class="session-status" *ngIf="isMonthKeyPast(month.monthName, month.year)">Session Passed</div>
        </div>
        
      </ng-container>
      
      <!-- Month has NO sessions — placeholder -->
      <div 
        class="cal-month no-session reveal"
        *ngIf="sessions.length === 0"
        [class.past-month]="isMonthKeyPast(month.monthName, month.year)">
        
        <span class="cal-tag">{{ month.monthName }} {{ month.year }}</span>
        <div class="cal-name">No Session Scheduled</div>
        <div class="cal-quote">—</div>
        <span class="cal-cause-label">TBD</span>
        <div class="cal-cause-desc">Check back for updates on this month's cause</div>
        <span class="cal-charity">To Be Announced</span>
        <div class="session-status">{{ isMonthKeyPast(month.monthName, month.year) ? 'Past Month' : 'Coming Soon' }}</div>
      </div>
      
    </ng-container>
    
  </ng-container>
</div>

    <div class="proceeds-note reveal"><strong>All net proceeds donated to support the cause</strong> — announced at the
      start of each registration window.</div>
  </div>
</section>

<!-- RESEARCH LAB -->
<section class="lab-section" id="lab">
  <div class="ng-grain"></div>
  <div class="lab-inner">
    <div class="lab-left">
      <div class="eyebrow1 reveal">NEXGEN Research Lab</div>
      <h2 class="reveal d1">Help move coaching<br><em>forward.</em></h2>
      <!-- <p class="lab-tagline reveal d1">Coaching is still a young field. There is so much more to discover about how
        humans grow, change, and thrive.</p> -->
      <div class="lab-rule reveal d1"></div>
      <p class="lab-body reveal d2">
        The NEXGEN Research Lab brings together people who want to study and explore the future of coaching.<br><br>
        Our goal is to support meaningful research that advances the coaching profession — and share what we discover
        with the world.
      </p>
      <div class="lab-questions reveal d3">
        <div class="ql">Together we can explore questions like:</div>
        <div class="qi">What makes coaching truly effective?</div>
        <div class="qi">How does coaching help people grow?</div>
        <div class="qi">How can coaching improve leadership and well-being?</div>
      </div>
    </div>
    <div class="lab-right">
      <div class="lab-who reveal d2">
        <div class="wl">We invite collaboration from:</div>
        <ul>
          <li>Researchers</li>
          <li>Universities</li>
          <li>Graduate students</li>
          <li>Academics</li>
          <li>Thought leaders</li>
          <li>Coaching practitioners</li>
        </ul>
      </div>
      <div class="lab-cta-box reveal d3">
        <p>Are you a <strong>researcher, coach educator, or doctoral student?</strong> The NEXGEN Research Lab is
          actively seeking contributors, collaborators, and institutional partners. Bring your work. Build something
          that lasts.</p>
        <a href="https://nexgencoaches.com/contact-us/" class="btn-gold-outline">Express Interest in Contributing</a>
      </div>
    </div>
  </div>
</section>

<!-- CLOSING CTA -->
<section class="ng-closing" id="join">
  <div class="dark-grid"></div>
  <div class="ng-grain"></div>
  <div class="closing-sweep"></div>
  <div class="closing-inner">
    <div class="eyebrow reveal" style="justify-content:center">Join the Community</div>
    <h2 class="reveal d1">You belong here.<br><em>Come as you are.</em></h2>
    <!-- <div class="crule reveal d2"></div> -->
    <p class="csub reveal d2">No credential requirement. No NEXGEN enrollment required. Just
      a real coaching community doing meaningful work together.</p>
    <div class="cbtns reveal d3">
      <button class="btn-gold" (click)="goToUrl()">Join the Community</button>
      <button class="btn-outline" (click)="openLatestUpcomingSessionModal()">Register for Coach for the Cause</button>
    </div>
  </div>
</section>

<!-- REGISTRATION MODAL -->
<div class="modal-overlay" *ngIf="showRegistrationModal" (click)="closeRegistrationModal()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Register for Session</h3>
      <button class="close-btn" (click)="closeRegistrationModal()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="modal-body">
      <!-- Session Summary -->
      <div class="session-summary" *ngIf="selectedSession">
        <h4>{{ selectedSession.title }}</h4>
        <p class="session-quote" *ngIf="selectedSession.quote">"{{ selectedSession.quote }}"</p>

        <div class="session-details">
          <div class="detail-row">
            <i class="bi bi-calendar3"></i>
            <span>{{ formatDate(selectedSessionDetail?.date) }}</span>
          </div>
          <div class="detail-row">
            <i class="bi bi-clock"></i>
            <span>{{ formatTime(selectedSessionDetail?.startTime) }} - {{ formatTime(selectedSessionDetail?.endTime)
              }} EST</span>
          </div>
          <div class="detail-row" *ngIf="selectedSession.charity">
            <i class="bi bi-heart"></i>
            <span>Supporting: <strong>{{ selectedSession.charity }}</strong></span>
          </div>
          <div class="detail-row price">
            <i class="bi bi-tag"></i>
            <span>Price: <strong>${{ selectedSession.price }}</strong></span>
          </div>
          <div class="detail-row spots">
            <i class="bi bi-people"></i>
            <span>{{ selectedSession.availableSpots }} of {{ selectedSession.totalSpots }} spots available</span>
          </div>
        </div>
      </div>

      <!-- Registration Form -->
      <div class="registration-form">
        <div class="form-group">
          <label>First Name *</label>
          <input type="text" [(ngModel)]="registrationForm.firstName" placeholder="Enter your first name">
        </div>

        <div class="form-group">
          <label>Last Name *</label>
          <input type="text" [(ngModel)]="registrationForm.lastName" placeholder="Enter your last name">
        </div>

        <div class="form-group">
          <label>Email Address *</label>
          <input type="email" [(ngModel)]="registrationForm.email" placeholder="Enter your email">
        </div>

        <div class="form-group checkbox">
          <label>
            <input type="checkbox" [(ngModel)]="registrationForm.agreeToTerms">
            <span>I agree to the <a href="https://nexgencoaches.com/terms-and-conditions/" target="_blank">Terms &
                Condtions</a> and <a href="https://nexgencoaches.com/privacy-policy/" target="_blank">Privacy
                Policy</a></span>
          </label>
        </div>

        <div class="form-group checkbox">
          <label>
            <input type="checkbox" [(ngModel)]="registrationForm.emailFollowUp">
            <span class="follow-up-text">
  I’m happy for NEXGEN to follow up by email. I know I can unsubscribe any time. <a href="https://nexgencoaches.com/privacy-policy/" target="_blank" rel="noopener noreferrer" style="color: #f4b921; text-decoration: none;">Privacy Policy</a>.
</span>
          </label>
        </div>

        <div class="payment-note">
          <i class="bi bi-lock"></i>
          <span>Secure payment via Stripe. You'll be redirected to complete your registration.</span>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn-secondary" (click)="closeRegistrationModal()">Cancel</button>
      <button class="btn-primary" (click)="registerForSession()">
        Proceed to Payment (${{ selectedSession?.price }})
      </button>
    </div>
  </div>
</div>

<app-bottomside></app-bottomside>